import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 主題策展
  {
    path: '/campaign/:aliasTwo?',
    name: 'techInside-home',
    component: () => lazyLoadView(import('@views/TechInside/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(!routeTo.params.aliasTwo){
            const aboutList = await store.dispatch('techInside/getList')
            routeTo.params.aliasTwo = aboutList.alias;
            routeTo.params.defaultValue = aboutList;
            next({path:`/campaign/${routeTo.params.aliasTwo}`,replace:true})
          }else{
            const aliasTwo = routeTo.params.aliasTwo;
            const aboutList = await store.dispatch('techInside/getListWithAlias', {
              curationAlias: aliasTwo,
            })
            routeTo.params.defaultValue = aboutList;
            next()
          }
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "campaign",
      title: '主題策展',
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue || {},
    })
  },
  {
    path: '/campaign/:aliastwo/:alias/',
    name: 'techInside-item',
    component: () => import('@views/TechInside/components/Theme'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const alias = routeTo.params.alias;
          const aliasTwo = routeTo.params.aliastwo;
          const data = await store.dispatch('techInside/getTopic', {
            curationAlias: aliasTwo,
            alias: alias,
          });
          routeTo.params.defaultValue = data.items;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "campaign",
      title: '主題策展',
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue || {},

    })
  },
]
